<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 委员会名称 -->
        <el-form-item label="委员会名称" prop="name">
            <el-input size="medium" class="inpText" v-model="params.name" placeholder="请输入标题"></el-input>
        </el-form-item>
        <!-- 缩略图 -->
        <el-form-item v-if="params.type==1" label="缩略图">
            <imgs-upload v-model="params.thumbnail" @imgChange="imgChange" tips="（推荐尺寸500*280）" />
        </el-form-item>
        <el-form-item v-else label="缩略图" prop="thumbnail">
            <imgs-upload v-model="params.thumbnail" @imgChange="imgChange" tips="（推荐尺寸500*280）" />
        </el-form-item>
        <!--  介绍 -->
        <el-form-item label="介绍" prop="introduce">
            <el-input style="width:750px;" type="textarea" v-model="params.introduce"></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item label="状态" prop="status">
            <el-radio-group v-model="params.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">停用</el-radio>
            </el-radio-group>
            &nbsp;&nbsp;&nbsp;&nbsp;停用后，将不在官网上展示，自定义链接不支持访问

        </el-form-item>

    </el-form>
</div>
</template>

<script>
export default {
    props: ['indata'],
    data() {
        return {
            params: {
                name: '',
                thumbnail: '',
                introduce: '',
                status: 0,
                type: 0,
            },
            rules: {

                name: [{
                    required: true,
                    message: '委员会名称不能为空',
                    trigger: 'blur'
                }],
                thumbnail: [{
                    required: true,
                    message: '缩略图不能为空',
                    trigger: 'blur'
                }],
                introduce: [{
                    required: true,
                    message: '介绍不能为空',
                    trigger: 'blur'
                }],

            }
        }
    },
    watch: {
        indata: function (e) {
            console.log(e);
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
            }
        }
    },
    methods: {
        imgChange(e) {
            console.log(e);
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {

                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },
    created: function () {
        var vues = this;
        
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.params);
        }

    }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}

.subpage .el-table__header tr,
.subpage .el-table__header th {
    padding: 0;
    height: 40px;
}

.subpage .el-table__body tr,
.subpage .el-table__body td {
    padding: 0;
    height: 40px;

}
</style>



// WEBPACK FOOTER //
// subpage1.vue?315dc713